import { cn } from '@/lib/utils'

interface TableLoadingOverlayProps {
  label?: string
  className?: string
}

/**
 * Centers on the visible bounds of its nearest `relative` ancestor rather
 * than the table's scrollable content, so it stays on screen even when the
 * table body collapses to a single row (e.g. while refetching a long,
 * scrolled list) or the user has scrolled away from the top of the table.
 */
export function TableLoadingOverlay({
  label = 'Loading...',
  className,
}: TableLoadingOverlayProps) {
  return (
    <div
      className={cn(
        'absolute inset-0 z-20 flex items-center justify-center bg-background/70 backdrop-blur-[2px]',
        className
      )}
    >
      <div className='flex flex-col items-center justify-center space-y-2'>
        <div className='w-8 h-8 border-4 border-primary/20 border-t-primary rounded-full animate-spin' />
        <p className='text-muted-foreground text-sm font-medium'>{label}</p>
      </div>
    </div>
  )
}
